import type {ReactNode} from 'react';
import {useRatingRadioGroupContext} from './RatingRadioGroupContext';

export type RatingRadioGroupListProps = {
  children: ReactNode;
};

export function RatingRadioGroupList({children}: RatingRadioGroupListProps) {
  const {onMouseLeave} = useRatingRadioGroupContext();

  return (
    <div className="RatingRadioGroup__list flex gap-2" onMouseLeave={onMouseLeave}>
      {children}
    </div>
  );
}
